// Module
var code = "<?xml version=\"1.0\" encoding=\"utf-8\"?> <svg id=\"MAIN\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\"> <polygon points=\"432.97 184.49 256 361.46 79.03 184.49 112.97 150.54 256 293.57 399.03 150.54 432.97 184.49\"/> </svg> ";
// Exports
module.exports = code;